const ALLOWED_PREFIXES = ['LEO', 'GIB'];   // GİB de GIB'e normalize edilir

const FILE_PATTERN    = /^([A-Za-zİı\u0307]+)(\d{4})(\d+)\.pdf$/i;
const INVOICE_PATTERN = /^(\d{4})(\d+)$/;

function normalizePrefix(text) {
  return String(text || '')
    .replace(/İ/g, 'I')      // noktali buyuk I
    .replace(/ı/g, 'i')      // noktasiz kucuk i
    .replace(/\u0307/g, '')  // kucuk harfe cevrilmis İ'den kalan birlesik nokta
    .toUpperCase();
}

const stripZeros = s => s.replace(/^0+/, '') || '0';

export function checkInvoiceFile(fileName, invoiceNo, allowedPrefixes = ALLOWED_PREFIXES) {
  const file = FILE_PATTERN.exec(String(fileName || '').trim());
  const inv  = INVOICE_PATTERN.exec(String(invoiceNo || '').trim());
  if (!file) return { ok: false, reason: 'Dosya adı beklenen biçimde değil.' };
  if (!inv)  return { ok: false, reason: 'Fatura numarası geçersiz.' };

  const prefix = normalizePrefix(file[1]);
  if (!allowedPrefixes.includes(prefix))
    return { ok: false, reason: 'Dosya ön eki LEO veya GİB olmalı.' };
  if (file[2] !== inv[1])
    return { ok: false, reason: `Dosyadaki yıl ${file[2]}, faturadaki yıl ${inv[1]}.` };
  if (stripZeros(file[3]) !== stripZeros(inv[2]))
    return { ok: false, reason: `Dosyadaki sıra no ${stripZeros(file[3])}, faturadaki ${stripZeros(inv[2])}.` };

  return { ok: true, reason: '', prefix };
}

export function isInvoiceFileValid(fileName, invoiceNo, allowedPrefixes = ALLOWED_PREFIXES) {
  return checkInvoiceFile(fileName, invoiceNo, allowedPrefixes).ok;
}


// WEBPACK FOOTER //
// ./src/utils/invoiceFileNameChecker.js